import type { MenuSettings } from "../../common/jsonRpcTypes";

export function extractHidePricesFromMenus(menus: MenuSettings[]): Record<string, boolean> {
  const result: Record<string, boolean> = {};
  for (const entry of menus) {
    if (entry?.menu_id) {
      // Hide prices if hide_prices is true, unless group member needs to pay
      const groupMemberMustPay = entry.who_pays === "group_member" && !!entry.payment_required;
      result[entry.menu_id] = !!entry.hide_prices && !groupMemberMustPay;
    }
  }
  return result;
}

export function extractHidePricesFromObject(obj: Record<string, MenuSettings>): Record<string, boolean> {
  const result: Record<string, boolean> = {};
  for (const entry of Object.values(obj)) {
    if (entry?.menu_id) {
      // Hide prices if hide_prices is true, unless group member needs to pay
      const groupMemberMustPay = entry.who_pays === "group_member" && !!entry.payment_required;
      result[entry.menu_id] = !!entry.hide_prices && !groupMemberMustPay;
    }
  }
  return result;
}

export function getHidePricesByMenu(
  customerPreorderSettings:
    | { menus?: MenuSettings[] }
    | MenuSettings[]
    | Record<string, MenuSettings>
    | null
    | undefined,
): Record<string, boolean> {
  if (!customerPreorderSettings) return {};
  if ("menus" in customerPreorderSettings && Array.isArray(customerPreorderSettings.menus)) {
    return extractHidePricesFromMenus(customerPreorderSettings.menus);
  }
  if (Array.isArray(customerPreorderSettings)) {
    return extractHidePricesFromMenus(customerPreorderSettings);
  }
  if (typeof customerPreorderSettings === "object") {
    return extractHidePricesFromObject(customerPreorderSettings as Record<string, MenuSettings>);
  }
  return {};
}
